var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"px-3 py-2 text-dark",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;_vm.collapse = !_vm.collapse}}},[_vm._t("header"),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.collapse),expression:"collapse"}]},[_vm._t("content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }